import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { SemanticAnalysisTopicForCsv } from '#modules/statistics-e-reputation/models/semantic-analysis.interface';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';

type Data = SemanticAnalysisTopicForCsv[] | undefined;

@Injectable()
export class SemanticAnalysisTopicsCsvInsightsService extends AbstractCsvService<Data> {
    private readonly _statisticsStore = inject(StatisticsStore);

    protected _getData$(): Observable<Data> {
        return of(this._statisticsStore.semanticAnalysisTopicsData());
    }

    protected override _isDataValid(data: Data): boolean {
        return !!data;
    }

    protected override _getCsvHeaderRow(): string[] {
        return [
            'Date Start',
            'Date End',
            'Category',
            'Topic',
            'Positive Count',
            'Evolution Positive',
            'Negative Count',
            'Evolution Negative',
        ];
    }

    protected override _getCsvDataRows(data: Exclude<Data, undefined>): CsvAsStringArrays {
        return data
            .filter(
                (topic) =>
                    !!topic.positiveCount ||
                    !!topic.negativeCount ||
                    !!topic.positiveCountEvolutionPercentage ||
                    !!topic.negativeCountEvolutionPercentage
            )
            .map((topic) => [
                topic.startDate,
                topic.endDate,
                topic.category,
                topic.name,
                topic.positiveCount.toString(),
                `${topic.positiveCountEvolutionPercentage.toString()}%`,
                topic.negativeCount.toString(),
                `${topic.negativeCountEvolutionPercentage.toString()}%`,
            ]);
    }
}
